import { Particle } from "../Particle";
import { adjustColor } from "../../utils/color";
import { TemperatureNormalization } from "../behaviors/TemperatureNormalization";
import { PhaseChange } from "../behaviors/PhaseChange";
import { Fire } from "./Fire";

export class Wood extends Particle {
    static baseColor = 0x855E42; // Rich Wood Brown

    constructor() {
        super({
            name: "Wood",
            color: adjustColor(Wood.baseColor, 12),
            behaviors: [
                new TemperatureNormalization(20, 0.1),
                // 高温自燃：当木头温度超过 300 度时，自动变成火
                new PhaseChange([
                    {
                        temp: 300,
                        type: 'above',
                        factory: () => new Fire()
                    }
                ])
            ], 
            props: { isFlammable: true, isMixable: false },
            temperature: 20,
            minTemp: -273,
            maxTemp: 1000
        });
    }
}
